export const Role = {
    admin: 'ADMINISTRADOR',
    documentacao: 'COMISSAO_DOCUMENTACAO', 
    pcd:'COMISSAO_PCD', 
    raca:'COMISSAO_RACA', 
    renda: 'COMISSAO_RENDA',
    candidato: 'CANDIDATO'
}
